<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><router-link to="/">Home</router-link></li>
        <li class="breadcrumb-item"><router-link to="/dashboard">Expedientes</router-link></li>
        <li class="breadcrumb-item active" aria-current="page">Notificaciones</li>
      </ol>
    </nav>
    <div class="notification-view">
      <div class="d-flex align-items-center mb-4">
        <h1 class="me-4 mb-0">Notificaciones</h1>
        <div class="flex-grow-1">
          <div class="dropdown-search">
            <input
              v-model="search"
              @focus="dropdownOpen = true"
              @input="dropdownOpen = true"
              @blur="closeDropdown"
              type="text"
              class="form-control"
              placeholder="Buscar expediente..."
              autocomplete="off"
            />
            <ul v-if="dropdownOpen && filteredProceedings.length" class="dropdown-menu show w-100 mt-1">
              <li v-for="p in filteredProceedings" :key="p.id">
                <a href="#" class="dropdown-item" @mousedown.prevent="selectProceeding(p)">
                  {{ p.number }} - {{ p.title || p.description || 'Sin título' }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div v-if="selectedProceeding">
        <h2 class="mb-3">Expediente: {{ selectedProceeding.number }}</h2>
        <div class="text-end mb-3">
          <button class="btn btn-primary" @click="showAddModal = true">Agregar Notificación</button>
        </div>
        <div class="table-responsive rounded shadow-sm">
          <table v-if="notifications.length > 0" class="table table-hover align-middle modern-table">
            <thead class="table-dark">
              <tr>
                <th>ID</th>
                <th>Notificación</th>
                <th>Descripción</th>
                <th>Activa</th>
                <th>Programada a</th>
                <th>Siguiente Ejecución</th>
                <th>Notificado?</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="notification in notifications" :key="notification.id">
                <td>{{ notification.id }}</td>
                <td>{{ notification.name }}</td>
                <td>{{ notification.description }}</td>
                <td>
                  <span :class="{'badge bg-success': notification.active, 'badge bg-danger': !notification.active}">
                    {{ notification.active ? 'Sí' : 'No' }}
                  </span>
                </td>
                <td>{{ formatDate(notification.scheduled_time).split(",")[1] }}</td>
                <td>{{ nextExcution(notification.scheduled_time) }}</td>
                <td>{{ taskStatus(notification.task_status) }}</td>
                <td>
                  <button class="btn btn-sm btn-warning me-2" @click="openEditModal(notification)" aria-label="Editar" data-bs-toggle="tooltip" title="Editar">
                    <i class="fas fa-edit" aria-label="Editar"></i>
                  </button>
                  <button @click="confirmDelete(notification.id)" class="btn btn-sm btn-danger" aria-label="Eliminar" data-bs-toggle="tooltip" title="Eliminar">
                    <i class="fas fa-trash" aria-label="Eliminar"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p v-if="notifications.length === 0">No hay notificaciones para este expediente.</p>
        <!-- Add Notification Modal -->
        <AddNotificationModal
          v-if="showAddModal"
          :proceeding-id="selectedProceeding.id"
          @close="showAddModal = false"
          @saved="onNotificationSaved"
        />
        <!-- Edit Notification Modal -->
        <EditNotificationModal
          v-if="showEditModal"
          :notification="editingNotification"
          :proceeding-id="selectedProceeding.id"
          @close="closeEditModal"
          @saved="onNotificationSaved"
        />
      </div>
      <div v-else class="alert alert-info mt-4">Seleccione un expediente para ver sus notificaciones.</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AddNotificationModal from '../components/AddNotificationModal.vue';
import EditNotificationModal from '../components/EditNotificationModal.vue';
export default {
  name: 'NotificationView',
  components: {
    AddNotificationModal,
    EditNotificationModal, 
  },
  data() {
    return {
      search: '',
      dropdownOpen: false,
      selectedProceeding: null,
      showAddModal: false,
      showEditModal: false,
      editingNotification: null,
    };
  },
  computed: {
    ...mapGetters({
      notifications: 'stateNotifications',
      allProceedings: 'stateProceedings',
    }),
    filteredProceedings() {
      if (!this.search) return this.allProceedings;
      const s = this.search.toLowerCase();
      return this.allProceedings.filter(p =>
        (p.number && p.number.toLowerCase().includes(s)) ||
        (p.title && p.title.toLowerCase().includes(s)) ||
        (p.description && p.description.toLowerCase().includes(s))
      );
    },
  },
  methods: {
    ...mapActions(['getNotifications', 'getProceedings', 'viewProceeding']),
    async fetchNotifications(proceedingId) {
      await this.getNotifications(proceedingId);
    },
    selectProceeding(p) {
      this.selectedProceeding = p;
      this.search = p.number;
      this.dropdownOpen = false;
      this.fetchNotifications(p.id);
    },
    closeDropdown() {
      setTimeout(() => {
        this.dropdownOpen = false;
      }, 150);
    },
    formatDate(time) {
      const date = new Date('2000-01-01 ' + time);
      const today = new Date();
      date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
      return date.toLocaleString('es-MX');
    },
    nextExcution(time) {
      const date = new Date('2000-01-01 ' + time);
      const today = new Date();
      date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate() + 1);
      return date.toLocaleString('es-MX');
    },
    taskStatus(task_status) {
      switch (task_status) {
        case 'scheduled':
          return 'Programado';
        case 'email_sent':
          return 'Notificado';
        default:
          return 'Por Programar';
      }
    },
    async confirmDelete(id) {
      if (confirm('¿Estás seguro de eliminar esta notificación?')) {
        await this.$store.dispatch('deleteNotification', id);
        if (this.selectedProceeding) {
          this.fetchNotifications(this.selectedProceeding.id);
        }
      }
    },
    openEditModal(notification) {
      this.editingNotification = notification;
      this.showEditModal = true;
    },
    closeEditModal() {
      this.showEditModal = false;
      this.editingNotification = null;
    },
    onNotificationSaved() {
      if (this.selectedProceeding) {
        this.fetchNotifications(this.selectedProceeding.id);
      }
      this.showAddModal = false;
      this.closeEditModal();
    },
  },
  async created() {
    await this.getProceedings();
  },
};
</script>

<style scoped>
.notification-view {
  padding: 20px;
}

.notification-view h1 {
  font-size: 24px;
  margin-bottom: 10px;
}

.breadcrumb {
  background-color: transparent;
  padding: 0;
  margin-bottom: 1rem;
}

.dropdown-search {
  position: relative;
}
.dropdown-search input.form-control {
  width: 100%;
  border-radius: 0.5rem;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04);
}
.dropdown-menu {
  max-height: 250px;
  overflow-y: auto;
  border-radius: 0.5rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  z-index: 1000;
}
.dropdown-item {
  cursor: pointer;
}
.table-responsive {
  background: #fff;
  border-radius: 1rem;
  box-shadow: 0 2px 12px rgba(0,0,0,0.07);
  padding: 1rem;
}
.modern-table th, .modern-table td {
  vertical-align: middle;
  font-size: 1rem;
}
.modern-table thead {
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  color: #fff;
}
.modern-table tbody tr:hover {
  background: #f6f8fa;
}
.btn-primary, .btn-warning, .btn-danger {
  border-radius: 0.5rem;
  font-weight: 500;
}
</style>

